<template>
  <div id="app-helper-modal" class="modal modal-fixed-footer" ref="modal">
    <div class="helper-title" v-html="activeHelper.title"></div>
    <div class="modal-content" v-if="helperData">
      <div v-if="activeHelper" class="row no-margins">
        <div class="helper-content">
          <!--  -->
          <div class="definitions-title" v-if="isDefinition">
            <i class="material-icons-outlined left">info</i> Definition: 
            <div class="clear"></div>
          </div>
          <!--  -->
          <div v-html="activeHelper.definition"></div>
          <!--  -->
          <div v-if="hasVideo" class="vid" style="z-index:999; position:relative">
            <youtube :player-vars="playerVars" :video-id="hasVideo" ref="youtube"/>
          </div>
          <!--  -->
        </div>

        <div class="slide-show gallery" v-if="helperStyle === 'slideshow'">
          <custom-slider  :data-slides="activeHelper.image_gallery"></custom-slider>
        </div>
        <div class="helper-images" v-else-if="!isDefinition && !helperStyle && !activeView">
          <div
            class="col s12"
            v-for="image in activeHelper.image_gallery"
            :key="image.ID"
          >
            <img :src="image.url" v-if="image.subtype !== 'pdf'" />
          </div>
         
          <div class="row no-margins">
    
            <!-- PDf only -->
            <div class="pdf-block" v-if="activeHelper.image_gallery.length === 1">
              <pdf-block v-if="pdfDocuments" :data-file="pdfDocuments.url" ></pdf-block>
            </div>
            <!-- listing  -->
            <div class="row" v-else>
            <div class="col s6" v-if="pdfDocuments" @click="activeView = pdfDocuments">
              <div class="card waves-effect waves-block">
                <div class="card-content">
                  <i class="material-icons grey-text text-darken-3 left">description</i> {{pdfDocuments.title}}
                </div>
              </div>
            </div>
            </div>
       

          </div>
        </div>
      </div>
      <div class="active-view" v-if="activeView">
        <button class="btn-floating waves-effect transparent z-depth-0" @click="activeView = false">
          <i class="material-icons grey-text text-darken-3">close</i>
        </button>
         <img :src="activeView.url" v-if="activeView.subtype !== 'pdf'" />
        <pdf-block v-else :data-file="pdfDocuments.url" ></pdf-block>
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-flat waves-effect  white"
        @click="$_close()"
      >
        Close
      </button>
    </div>
  </div>
</template>
<script>
import customSlider from '@/components/customSlider'
import PdfBlock from '@/components/pdfBlock.component.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import M from 'materialize-css'
export default {
  name: 'HelperModal',
  props: {},
  components: {
    PdfBlock, customSlider
  },
  data() {
    let vm = this;
    return {
      activeView: false,
      playerVars: {
        'modestbranding': 1,
        'autoplay': 0,
        'controls': 2,
        'rel': 0,
        'fs': 0,
        'iv_load_policy': 3,
        'enablejsapi': 0
      },
      modal: {
        instance: null,
        options: {
          onCloseEnd: () => {
            vm.setHelper(null);
          },
        },
      },
      helperData: null,
    };
  },
  mounted() {
    this.$_initModal();
    this.$_getHelper();
  },
  beforeDestroy() {
    if (this.modal.instance) this.modal.instance.destroy();
    this.setHelper(null);
  },
  computed: {
    ...mapGetters({
      helpers: "Helpers/allHelpers",
    }),
    ...mapState({
      helperId: state => state.Helpers.helper,
      helperStyle: state => state.Helpers.style
    }),
    isDefinition() {
      return this.helperId.includes("D");
    },
    activeHelper: {
      get() {
        return this.helpers.find((x) => x.helper_id === this.helperId);
      }
    },
    pdfDocuments: {
      get() {
        return this.activeHelper.image_gallery ? this.activeHelper.image_gallery.find((x) => x.subtype === "pdf") : false
      }
    },
    hasVideo: {
      get() {
        return this.activeHelper.youtube_id ? this.activeHelper.youtube_id : false
      }
    },
  },
  methods: {
    ...mapActions("Helpers", ["setHelper"]),
    $_getHelper() {
      const val = this.helpers.find(
        ({ helper_id }) => helper_id === this.helperId
      );
      if (val) {
        this.helperData = val;
      }
    },
    $_initModal() {
      this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options);
      setTimeout(() => {
        this.modal.instance.open();
      });
    },
    $_close() {
      this.setHelper(null);
      this.modal.instance.close();
    },
  },
};
</script>
<style scoped lang="scss">
#app-helper-modal {
  &.modal {
    top:10px !important;
    width: 96%;
    min-height: 90%;
    border-radius: 5px;
    @media screen and (min-width: 768px) {
      max-width: 768px;
    }
    .modal-content {
      height:calc(100% - 104px);
    }
  }
  .helper-images {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    img {
      max-width: 100%;
    }
  }

}
.helper-title {
  font-size: 20px;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  padding: 0 16px;
}
.pdf-block {
    position: absolute;
    width: 100%;
    height: 100%;
}
.definitions-title {
    font-size: 14px;
    font-style: italic;
    margin-bottom: 3px;
    font-weight: 300;
    i {
        margin-right: 6px;
        vertical-align: middle;
        font-size: 18px;
        line-height: 21px;
    }
}
.active-view {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
  padding: 12px;
  width: 100%;
  height: 100%;
  background: white;
  button {
    position: absolute;
    right: 16px;
    top: 16px;
  }
  img {
      max-width: 100%;
    }
}
.slide-show {
  &.gallery {
    height: calc(100vh - 212px);
}
}
</style>
<style lang="scss">
.vid {
  margin-top: 12px;
  width: 100%;
  iframe {
    width: 100%;
  }
}
</style>
